var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9494 10.144C5.9494 5.9694 9.32579 2.59302 13.5004 2.59302C17.6751 2.59302 21.0514 5.9694 21.0514 10.144C21.0514 14.6423 16.2835 20.8449 14.331 23.2073C13.8995 23.7251 13.1121 23.7251 12.6806 23.2073C10.7173 20.8449 5.9494 14.6423 5.9494 10.144ZM10.8028 10.1431C10.8028 11.6317 12.0109 12.8399 13.4995 12.8399C14.9882 12.8399 16.1963 11.6317 16.1963 10.1431C16.1963 8.65444 14.9882 7.44628 13.4995 7.44628C12.0109 7.44628 10.8028 8.65444 10.8028 10.1431Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.41de19d12c3300357922f3d027096486.svg";
export { ForwardRef as ReactComponent };